import { type FormConfig } from '@acme/foundation';

export const organizationFormConfig = (): FormConfig => ({
  id: 'organization-form',
  controls: [
    {
      id: 'organization.name',
      label: 'Название',
      type: 'text',
      read: (ctx: any) => ctx?.name || '',
      write: { path: 'name' },
      props: {
        placeholder: 'Введите название организации',
      },
    },
    {
      id: 'organization.inn',
      label: 'ИНН',
      type: 'text',
      read: (ctx: any) => ctx?.inn || '',
      write: { path: 'inn' },
      props: {
        placeholder: 'Введите ИНН организации',
      },
    },
    {
      id: 'organization.ogrn',
      label: 'ОГРН',
      type: 'text',
      read: (ctx: any) => ctx?.ogrn || '',
      write: { path: 'ogrn' },
      props: {
        placeholder: 'Введите ОГРН',
      },
    },
    {
      id: 'organization.legalAddress',
      label: 'Юр. адрес',
      type: 'text',
      read: (ctx: any) => ctx?.legalAddress || '',
      write: { path: 'legalAddress' },
      props: {
        placeholder: 'Введите юридический адрес',
      },
    },
    {
      id: 'organization.phoneNumber',
      label: 'Телефон',
      type: 'text',
      read: (ctx: any) => ctx?.phoneNumber || '',
      write: { path: 'phoneNumber' },
      props: {
        placeholder: 'Введите номер телефона организации',
      },
    },
    {
      id: 'organization.bankDetail.accountNumber',
      label: 'Номер счёта в банке',
      type: 'text',
      read: (ctx: any) => ctx?.bankDetail?.accountNumber || '',
      write: { path: 'bankDetail.accountNumber' },
      props: {
        placeholder: 'Введите номер счёта',
      },
    },
    {
      id: 'organization.bankDetail.name',
      label: 'Наименование банка',
      type: 'text',
      read: (ctx: any) => ctx?.bankDetail?.name || '',
      write: { path: 'bankDetail.name' },
      props: {
        placeholder: 'Введите название банка',
      },
    },
    {
      id: 'organization.bankDetail.identificationCode',
      label: 'БИК',
      type: 'text',
      read: (ctx: any) => ctx?.bankDetail?.identificationCode || '',
      write: { path: 'bankDetail.identificationCode' },
      props: {
        placeholder: 'Введите БИК',
      },
    },
    {
      id: 'organization.bankDetail.correspondentAccount',
      label: 'Корр. счёт',
      type: 'text',
      read: (ctx: any) => ctx?.bankDetail?.correspondentAccount || '',
      write: { path: 'bankDetail.correspondentAccount' },
      props: {
        placeholder: 'Введите корреспондентский счёт',
      },
    },
    {
      id: 'organization.role',
      label: 'Роль на платформе',
      type: 'text',
      read: (ctx: any) => ctx?.role?.value || '',
      write: { path: 'role' },
      props: {
        placeholder: 'Роль',
        disabled: true,
      },
    },
    {
      id: 'organization.responsiblePersonName',
      label: 'Ответственное лицо',
      type: 'text',
      read: (ctx: any) => ctx?.responsiblePersonName || '',
      write: { path: 'responsiblePersonName' },
      props: {
        placeholder: 'Введите ФИО ответственного лица',
      },
    },
    {
      id: 'organization.actualAddress',
      label: 'Физ. адрес',
      type: 'text',
      read: (ctx: any) => ctx?.actualAddress || '',
      write: { path: 'actualAddress' },
      props: {
        placeholder: 'Введите физический адрес',
      },
    },
  ],
});
